<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Recharge Order ID" prop="menuId" >
        <a-input v-model="form.menuId" placeholder="Please enter recharge order ID" />
      </a-form-model-item>
      <a-form-model-item label="User ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="Please enter user ID" />
      </a-form-model-item>
      <a-form-model-item label="Recharge Amount" prop="rechargeMoney" >
        <a-input v-model="form.rechargeMoney" placeholder="Please enter recharge amount" />
      </a-form-model-item>
      <a-form-model-item label="Pay Amount" prop="payMoney" >
        <a-input v-model="form.payMoney" placeholder="Please enter pay amount" />
      </a-form-model-item>
      <a-form-model-item label="Payment Method (0-VISA 1-Mastercard 2-ApplePay 3-GooglePay)" prop="payType" >
      </a-form-model-item>
      <a-form-model-item label="Payment Status (0-Unpaid 1-Paid 2-Failed)" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="Remark" prop="remark" >
        <a-input v-model="form.remark" placeholder="Please enter content" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRechargeOrder, addRechargeOrder, updateRechargeOrder } from '@/api/golf/rechargeOrder'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,

        menuId: null,

        userId: null,

        rechargeMoney: null,

        payMoney: null,

        payType: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        menuId: null,
        userId: null,
        rechargeMoney: null,
        payMoney: null,
        payType: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRechargeOrder(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRechargeOrder(this.form).then(response => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
